import React, { useState } from "react";
import { useTranslation } from "react-i18next";

interface PaginationProps {
  totalPages: number;
  total_item_count: number;
  _itemsPerPage?: number;
  _currentPage?: number;
  isCoursePage?: boolean;
  handleChange: ({
    itemsPerPage,
    page,
  }: {
    page: number;
    itemsPerPage: number;
  }) => void;
}

function Pagination({
  totalPages,
  total_item_count,
  _currentPage,
  _itemsPerPage,
  isCoursePage = false,
  handleChange,
}: PaginationProps) {
  const [currentPage, setCurrentPage] = useState(_currentPage || 1); // Current page state
  const { t } = useTranslation();

  const [itemsPerPage, setItemsPerPage] = useState(_itemsPerPage || 4); // Items per page state

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handleChange({ page, itemsPerPage });
  };
  const handleItemsPerPageChange = (itemsPerPage: number) => {
    setItemsPerPage(itemsPerPage);
    setCurrentPage(1);
    handleChange({ page: 1, itemsPerPage });
  };

  const isMobileOrTablet = window.innerWidth < 1024; // Checking for mobile/tablet screens

  return (
    // <div className="flex justify-between items-center w-full gap-10">
    //   <div className="flex justify-center items-center gap-4 mt-4">
    //     {/* Previous Button */}
    //     <button
    //       className={`px-4 py-2 border rounded ${
    //         currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
    //       }`}
    //       onClick={() => handlePageChange(currentPage - 1)}
    //       disabled={currentPage === 1}
    //     >
    //       {t("Previous")}
    //     </button>

    //     {/* Dynamic Page Buttons */}
    //     {Array.from({ length: Math.min(totalPages, 4) }).map((_, index) => {
    //       const startPage = Math.max(
    //         1,
    //         Math.min(currentPage - 1, totalPages - 3)
    //       );
    //       const pageNumber = startPage + index;

    //       return (
    //         <button
    //           key={pageNumber}
    //           className={`px-4 py-2 border rounded ${
    //             currentPage === pageNumber
    //               ? "bg-[#961e38] text-white"
    //               : "bg-white text-[#961e38]"
    //           }`}
    //           onClick={() => handlePageChange(pageNumber)}
    //         >
    //           {pageNumber}
    //         </button>
    //       );
    //     })}

    //     {/* Next Button */}
    //     <button
    //       className={`px-4 py-2 border rounded ${
    //         currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
    //       }`}
    //       onClick={() => handlePageChange(currentPage + 1)}
    //       disabled={currentPage === totalPages}
    //     >
    //       {t("Next")}
    //     </button>
    //   </div>
    //   <div className="flex justify-center items-center gap-5">
    //     <p className="text-sm font-semibold">
    //       {t("Showing")} {itemsPerPage * (currentPage - 1) + 1} -{" "}
    //       {Math.min(itemsPerPage * currentPage, total_item_count || 0)}{" "}
    //       {t("of")} {total_item_count || 0} {t("results")}
    //     </p>
    //     <div className="flex items-center gap-3">
    //       <p className="text-sm font-semibold">{t("Items per page")}:</p>
    //       <select
    //         value={itemsPerPage}
    //         onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
    //       >
    //         <option value={4}>4</option>
    //         <option value={8}>8</option>
    //         <option value={12}>12</option>
    //       </select>
    //     </div>
    //   </div>
    // </div>
    <div className="flex flex-col md:flex-row justify-between items-center w-full gap-10">
      <div className="flex md:flex-row justify-center items-center gap-4 mt-4">
        {/* Previous Button */}
        <button
          className={`px-4 py-2 border rounded ${
            currentPage === 1 ? "cursor-not-allowed opacity-50" : ""
          }`}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          {t("Previous")}
        </button>

        {/* Dynamic Page Buttons */}
        {Array.from({
          length: Math.min(totalPages, isMobileOrTablet ? 2 : 4),
        }).map((_, index) => {
          const startPage = Math.max(
            1,
            Math.min(currentPage - 1, totalPages - 3)
          );
          const pageNumber = startPage + index;

          return (
            <button
              key={pageNumber}
              className={`px-4 py-2 border rounded ${
                currentPage === pageNumber
                  ? "bg-[#961e38] text-white"
                  : "bg-white text-[#961e38]"
              }`}
              onClick={() => handlePageChange(pageNumber)}
            >
              {pageNumber}
            </button>
          );
        })}

        {/* Next Button */}
        <button
          className={`px-4 py-2 border rounded ${
            currentPage === totalPages ? "cursor-not-allowed opacity-50" : ""
          }`}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {t("Next")}
        </button>
      </div>
      <div className="flex flex-col md:flex-row justify-center items-center gap-5 mt-4 md:mt-0">
        <p className="text-sm font-semibold">
          {t("Showing")}{" "}
          {itemsPerPage * (currentPage - 1) === 0
            ? total_item_count > 0
              ? 1
              : 0
            : itemsPerPage * (currentPage - 1) + 1}{" "}
          - {Math.min(itemsPerPage * currentPage, total_item_count || 0)}{" "}
          {t("of")} {total_item_count || 0} {t("results")}
        </p>
        <div className="flex items-center gap-3">
          <p className="text-sm font-semibold">{t("Items per page")}:</p>
          {isCoursePage ? (
            <select
              value={itemsPerPage}
              onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
              className="border rounded p-1"
            >
              <option value={12}>12</option>
              <option value={20}>20</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
            </select>
          ) : (
            <select
              value={itemsPerPage}
              onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
              className="border rounded p-1"
            >
              <option value={4}>4</option>
              <option value={8}>8</option>
              <option value={12}>12</option>
            </select>
          )}
        </div>
      </div>
    </div>
  );
}

export default Pagination;
